export default __webpack_public_path__ + "static/media/Bathroom2.f6846a68.jpeg";